module.exports = __webpack_public_path__ + "img/PS02.b33d52a5.png";